export default __webpack_public_path__ + "static/media/ecosystem-of-partners-2x.51261f88.jpg";